<template>
    <div>
        <b-field label="Trigger for room rates that are"></b-field>
            <b-field class="commonrules-grp my-4" >
                <b-radio :native-value="true" :value="refundableValue" @input="emitRefundable">
                    Non-Refundable
                </b-radio>
                <b-radio :native-value="false" :value="refundableValue" @input="emitRefundable">
                    Refundable
                </b-radio>
            </b-field>
    </div>
</template>
<script>

export default {
    name: "HotelRefundable",
    props: { refundableVal: null },
    data() {
        return {
            refundableValue: null,
        }
    },
    methods: {
        emitRefundable(val) {
        this.refundableValue = val;
        this.$emit("emitData", val);
    },
    },
    mounted() {
        this.refundableValue = this.refundableVal;
    }
}
</script>